import { render, staticRenderFns } from "./directInitiation_pay.vue?vue&type=template&id=19257742&scoped=true&"
import script from "./directInitiation_pay.vue?vue&type=script&lang=js&"
export * from "./directInitiation_pay.vue?vue&type=script&lang=js&"
import style0 from "./directInitiation_pay.vue?vue&type=style&index=0&id=19257742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19257742",
  null
  
)

export default component.exports